export default __webpack_public_path__ + "static/media/portfolio-141.acd947c3.jpg";